module.exports = __webpack_public_path__ + "assets/chat-bg-1.028929fe.svg";